import router from "next/router";
import { useEffect } from "react";

export const useRedirectIfConditionMet = ({
    condition,
    url,
}: {
    condition: any;
    url: string;
}) => {
    useEffect(() => {
        if (condition) {
            router.push(url);
        }
    }, [condition, url]);
};
